import { computed } from 'vue';

import { paramCase, propsFactory } from '@components/utils';

import { useProxyModel } from './proxyModel';

import type { ComputedRef, PropType, Ref } from 'vue';

export interface IFocusProps {
  focused: boolean;
}
export interface IUseFocus {
  isFocused: Ref<boolean>;
  focusClasses: ComputedRef<Record<string, boolean>>;
  focus: () => void;
  blur: () => void;
}

export const makeFocusProps = propsFactory(
  {
    /**
     * Элемент в фокусе
     */
    focused: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'focus'
);

export function useFocus(props: IFocusProps, name: string): IUseFocus {
  const isFocused = useProxyModel(props, 'focused');
  const focusClasses = computed(() => ({
    [`${paramCase(name)}--focused`]: isFocused.value
  }));

  function focus() {
    isFocused.value = true;
  }

  function blur() {
    isFocused.value = false;
  }

  return { focusClasses, isFocused, focus, blur };
}
